// src/data/projects.js
export const projects = [
  {
    id: 1,
    title: 'Interactive Todo App',
    description: 'A small React + Vite todo application with localStorage persistence, filters and animated transitions.',
    tags: ['React', 'Vite', 'LocalStorage'],
    image: 'https://images.unsplash.com/photo-1555066931-4365d14bab8c?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3&s=5f2c8e1f0d7349f9e05f1a9a3a3b4a1f',
    url: '#'
  },
  {
    id: 2,
    title: 'Portfolio Website',
    description: 'This portfolio built with Vite and React — responsive, animated hero, and project cards.',
    tags: ['React', 'CSS', 'Vite'],
    image: 'https://images.unsplash.com/photo-1508780709619-79562169bc64?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3&s=efb1b4a2b1c8c1d7b5f6a3a2b4d2e5f7',
    url: '#'
  },
  {
    id: 3,
    title: 'Weather Dashboard',
    description: 'A weather dashboard showing current and forecasted conditions using a public API.',
    tags: ['API', 'Fetch', 'Responsive'],
    image: 'https://images.unsplash.com/photo-1601134467661-3d775b999c8b?w=800&auto=format&fit=crop&q=80',
    url: '#'
  }
];
